import { useSite } from "../context/SiteContentContext";
import { Instagram, Heart } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = ({ onReserveClick }) => {
    const siteConfig = useSite();
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[#0a0a0a] border-t border-[#262626] pt-24 pb-10 px-6 md:px-12"
        >
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-[#262626]">
                    <div className="md:col-span-6">
                        <div className="flex items-start gap-6 mb-2">
                            <img
                                src="/logo-barbearia18-light.png"
                                alt={siteConfig.brand.name}
                                className="h-32 md:h-40 w-auto opacity-90"
                                draggable={false}
                                loading="lazy"
                            />
                            <div className="hidden md:block w-px h-32 bg-[#262626] mt-4" />
                            <div className="hidden md:flex flex-col justify-center">
                                <h3 className="font-display text-3xl lg:text-5xl font-black tracking-tighter leading-none text-[#f5f5f0]">
                                    {siteConfig.brand.name}
                                    <span className="text-[#d4af37]">.</span>
                                </h3>
                                <p className="text-xs tracking-widest uppercase text-[#737373] mt-3">
                                    Est. 2018 · Sintra
                                </p>
                            </div>
                        </div>
                        <p className="mt-6 max-w-md text-[#a3a3a3] leading-relaxed">
                            Barbeiro em Sintra. Reservas online sem app, sem
                            conta, sem complicações.
                        </p>
                        <button
                            onClick={onReserveClick}
                            data-testid="footer-reserve-btn"
                            className="mt-8 inline-flex items-center gap-3 px-8 py-4 bg-[#d4af37] text-[#0a0a0a] font-semibold tracking-wide uppercase text-sm hover:bg-[#b3912e] transition-all duration-300 rounded-sm"
                        >
                            Reservar horário
                        </button>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs tracking-widest uppercase text-[#737373] mb-5">
                            Navegar
                        </div>
                        <ul className="space-y-3">
                            <FooterLink href="#services" label="Serviços" />
                            <FooterLink href="#about" label="Sobre" />
                            <FooterLink href="#gallery" label="Galeria" />
                            <FooterLink href="#contact" label="Contactos" />
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs tracking-widest uppercase text-[#737373] mb-5">
                            Segue
                        </div>
                        <a
                            href={siteConfig.contact.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-instagram"
                            className="inline-flex items-center gap-3 text-[#f5f5f0] hover:text-[#d4af37] transition-colors"
                        >
                            <Instagram size={18} />
                            <span>{siteConfig.contact.instagramHandle}</span>
                        </a>
                        <div className="mt-6 text-sm text-[#a3a3a3]">
                            {siteConfig.contact.address}
                        </div>
                    </div>
                </div>

                <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#737373]">
                    <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-6">
                        <span>
                            © {new Date().getFullYear()}{" "}
                            {siteConfig.brand.name}. Todos os direitos
                            reservados.
                        </span>
                        <div className="flex items-center gap-2">
                            <Link
                                to="/privacidade"
                                data-testid="footer-privacy-link"
                                className="px-2 py-2 hover:text-[#d4af37] transition-colors"
                            >
                                Privacidade
                            </Link>
                            <span className="text-[#3a3a3a]">·</span>
                            <Link
                                to="/cookies"
                                data-testid="footer-cookies-link"
                                className="px-2 py-2 hover:text-[#d4af37] transition-colors"
                            >
                                Cookies
                            </Link>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        Feito com <Heart size={12} className="text-[#d4af37]" />
                        <span>em Sintra</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

const FooterLink = ({ href, label }) => (
    <li>
        <a
            href={href}
            onClick={(e) => {
                e.preventDefault();
                document
                    .querySelector(href)
                    ?.scrollIntoView({ behavior: "smooth" });
            }}
            className="text-[#a3a3a3] hover:text-[#d4af37] transition-colors text-sm"
        >
            {label}
        </a>
    </li>
);
